import React, { useState } from 'react';
// @ts-ignore
import styles from './Label.module.scss';
import Text from '../Text/Text';
import { joinClasses } from '../../../Utils/className.util';
import Tooltip from '../../Popup/Tooltip';
import InfoTooltip from '../../Popup/InfoTooltip';

interface ILabel {
	tx: string;
	isOptional?: boolean;
	firstUpper?: boolean;
	className?: any;
	style?: any;
	isMaxContentWidth?: boolean;
	tooltip?: string;
}

export default function Label(props: ILabel) {
	const {
		tx,
		isOptional = false,
		firstUpper = false,
		isMaxContentWidth = false,
		className,
		style,
		tooltip,
	} = props;

	return tx ? (
		<div className={joinClasses([styles.wrapper, className])}>
			<Text
				className={joinClasses([
					styles.title,
					isMaxContentWidth ? styles.maxContent : undefined,
				])}
				tx={tx}
				firstUpper={firstUpper}
				style={style}
			/>
			{tooltip && (
				<InfoTooltip>
					<Text tx={tooltip} />
				</InfoTooltip>
			)}
			{isOptional && (
				<Text className={styles.optional} tx={'base.notRequired'} />
			)}
		</div>
	) : null;
}
